import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { externalLinks } from 'src/externalLinks';
import { Trainer } from 'src/models/trainer/trainer';

export interface ItemType {
  label: string;
  pluralLabel: string;
  value: string;
  modelName: string;
  icon: any;
  manageLink?: string;
  supportsQuantity: boolean;
  hide?: (trainer?: Trainer) => boolean;
}

export const selectableItemTypes: ItemType[] = [
  {
    label: 'Package',
    pluralLabel: 'Packages',
    value: 'package',
    modelName: 'Fbm::Package',
    icon: icon({ name: 'box', style: 'regular' }),
    manageLink: externalLinks.managePackages(),
    supportsQuantity: false,
  },
  {
    label: 'Group',
    pluralLabel: 'Groups',
    value: 'group',
    modelName: 'Group',
    icon: icon({ name: 'users', style: 'regular' }),
    manageLink: '/groups',
    supportsQuantity: false,
    hide: (trainer?: Trainer) => !!trainer,
  },
  {
    label: 'Plan',
    pluralLabel: 'Plans',
    value: 'plan',
    modelName: 'WorkoutPlan',
    icon: icon({ name: 'list-check', style: 'regular' }),
    manageLink: '/workout-plans',
    supportsQuantity: false,
    hide: (trainer?: Trainer) => !!trainer,
  },
  {
    label: 'Product',
    pluralLabel: 'Products',
    value: 'product',
    modelName: 'Exercisecom::Product',
    icon: icon({ name: 'boxes-packing', style: 'regular' }),
    manageLink: '/products',
    supportsQuantity: true,
  },
  {
    label: 'Product Variant',
    pluralLabel: 'Product Variants',
    value: 'productVariant',
    modelName: 'ProductVariant',
    icon: icon({ name: 'boxes-packing', style: 'regular' }),
    manageLink: '/products',
    supportsQuantity: true,
    hide: () => true,
  },
  {
    label: 'Online Training',
    pluralLabel: 'Online Training',
    value: 'onlineTraining',
    modelName: 'onlineTraining',
    icon: icon({ name: 'globe', style: 'regular' }),
    manageLink: externalLinks.customizePlatformClientSettings(),
    supportsQuantity: false,
    hide: (trainer?: Trainer) => !!trainer,
  },
  {
    label: 'Staff Subscription',
    pluralLabel: 'Staff Subscription',
    value: 'staffSubscription',
    modelName: 'StaffSubscription',
    icon: icon({ name: 'user-pen', style: 'regular' }),
    manageLink: undefined,
    supportsQuantity: false,
    hide: (trainer?: Trainer) => !trainer,
  },
];

/**
 * Get the display label for an itemType modelName
 * Maps model names like "Fbm::Package" to display names like "Package"
 */
export const getItemTypeLabel = (modelName: string): string => {
  const itemType = selectableItemTypes.find((t) => t.modelName === modelName);
  return itemType?.label || modelName;
};
